import { useEffect } from "react";

import { useLazyQuery } from "@apollo/client";

import {
  GetDeviceTemplatesQuery,
  GetDeviceTemplatesQueryVariables,
} from "../../../../../API";
import { GET_DEVICE_TEMPLATES } from "../../../../../common/operations/queries";
import { errorNotification } from "../../../../../common/variables/notification";
import client from "../../../../../configs/apolloClient";
import { DEFAULT_LIMIT_COUNT } from "../../../../../common/variables/common";

interface IUseGetLazyPaginatedDeviceTemplates {
  data?: GetDeviceTemplatesQuery;
  loading: boolean;
}

export const useGetLazyPaginatedDeviceTemplates =
  (): IUseGetLazyPaginatedDeviceTemplates => {
    useEffect((): void => {
      fetchDeviceTemplates(DEFAULT_LIMIT_COUNT);
    }, []);

    const [getDeviceTemplates, { data, loading }] = useLazyQuery<
      GetDeviceTemplatesQuery,
      GetDeviceTemplatesQueryVariables
    >(GET_DEVICE_TEMPLATES, {
      fetchPolicy: "network-only",
    });

    const handleRequestError = async (): Promise<void> => {
      await client.cache.reset();

      errorNotification();
    };

    const fetchDeviceTemplates = (limit: number, nextToken?: string): void => {
      getDeviceTemplates({
        variables: {
          limit,
          nextToken,
        },
      })
        .then(async (response): Promise<void> => {
          if (response.data?.getDeviceTemplates.nextToken) {
            fetchDeviceTemplates(
              DEFAULT_LIMIT_COUNT,
              response.data?.getDeviceTemplates.nextToken
            );
          }

          if (response.error) {
            await handleRequestError();
          }
        })
        .catch(async (): Promise<void> => {
          await handleRequestError();
        });
    };

    return { data, loading };
  };
